import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { OAuthToComponent } from './OAuthMapping';
import Separator from '../step-landing-page/Separator';
import { Step } from '../views/Step';
import { useOAuthSignup } from './useOAuthSignup';
import { OAuthProviders } from './OAuthProviders';
import { OAuthVerificationFailureText } from './OAuthVerificationFailureText';
import { useIsFramedCentredStep } from '../hooks/useIsFramedCentredStep';
import { OAuthButton } from './OAuthButton';
import { TrackWhen, useExperiment } from '../experiments/useExperiment';
import { ExperimentKeys } from '../experiments/ExperimentKeys';
import { ExperimentParameterGroup } from '../experiments/ExperimentParameterGroup';
const Acq131VariantToOAuthProviderRecord = {
  [ExperimentParameterGroup.Variant_A]: OAuthProviders.Wordpress,
  [ExperimentParameterGroup.Variant_B]: OAuthProviders.Apple,
  [ExperimentParameterGroup.Variant_C]: OAuthProviders.LinkedIn,
  [ExperimentParameterGroup.Variant_D]: OAuthProviders.PayPal
};
export const OAuthSignupSection = () => {
  const {
    oAuthsEnabledByFlowConfig,
    atLeastOneOAuthEnabled
  } = useOAuthSignup();
  const {
    isFramedCentredStep
  } = useIsFramedCentredStep();
  const {
    isAssignedToVariant: getIsAcq131Variant,
    parameter: acq131Parameter
  } = useExperiment(ExperimentKeys.ACQ131, TrackWhen.enrolled);

  const renderOAuths = () => {
    const oAuths = Object.keys(oAuthsEnabledByFlowConfig).filter(oAuth => oAuthsEnabledByFlowConfig[oAuth]).map(oAuth => {
      return /*#__PURE__*/_jsxs("div", {
        children: [OAuthToComponent[oAuth], /*#__PURE__*/_jsx(OAuthVerificationFailureText, {
          oAuth: oAuth
        })]
      }, oAuth);
    });
    return oAuths;
  };

  const renderAcq131BrokenOAuth = () => {
    const isAcq131Variant = getIsAcq131Variant();
    const oAuthProvider = Acq131VariantToOAuthProviderRecord[acq131Parameter];

    if (!isAcq131Variant || !oAuthProvider) {
      return null;
    }

    return /*#__PURE__*/_jsx(OAuthButton, {
      oauth: oAuthProvider
    });
  };

  return /*#__PURE__*/_jsxs("div", {
    className: isFramedCentredStep ? 'm-top-4' : 'm-top-6',
    children: [renderOAuths(), renderAcq131BrokenOAuth(), atLeastOneOAuthEnabled && /*#__PURE__*/_jsx(Separator, {
      message: `views.${Step.LandingPage}.separator`
    })]
  });
};